/** Small formatters for a table full of timestamps and byte counts. */

const dateTime = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const dateOnly = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export const formatDateTime = (ms: number | null): string =>
  ms === null ? '—' : dateTime.format(new Date(ms));

export const formatDate = (ms: number | null): string =>
  ms === null ? '—' : dateOnly.format(new Date(ms));

/** "3 min ago", "2 days ago", or the date once it is older than a month. */
export const formatAgo = (ms: number | null, now = Date.now()): string => {
  if (ms === null) return 'never';
  const delta = Math.max(0, now - ms);
  const minute = 60_000;
  const hour = 60 * minute;
  const day = 24 * hour;
  if (delta < minute) return 'just now';
  if (delta < hour) return `${Math.floor(delta / minute)} min ago`;
  if (delta < day) return `${Math.floor(delta / hour)} h ago`;
  if (delta < 31 * day) return `${Math.floor(delta / day)} d ago`;
  return dateOnly.format(new Date(ms));
};

export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${units[unit]}`;
};

export const formatCount = (n: number): string => new Intl.NumberFormat('en-GB').format(n);

/** The first eight characters of an id — enough to tell two apart on a page. */
export const shortId = (id: string): string => id.slice(0, 8);
